The date which the associated object is no longer effective.

For example, this corresponds to the expiry date of certifications.
This will be `null` if the associated object does not expire.
